import { defineComponent as s, resolveComponent as i, createElementBlock as l, openBlock as a, createVNode as p, createElementVNode as e } from "vue";
import { v as m } from "./vsIcon-Cyr63bPF.mjs";
import { _ as d } from "./_plugin-vue_export-helper-CHgC5LLL.mjs";
const f = s({
  name: "vs-toast",
  components: {
    vsIcon: m
  },
  props: {
    type: { type: String, default: "error" },
    text: { type: String, default: "" },
    duration: { type: Number, default: 3e5 },
    hideProgressBar: { type: Boolean, default: !0 }
  },
  setup(o, { emit: t }) {
    return { content: {
      error: {
        color: "error",
        icon: "carbon:close-filled"
      },
      warning: {
        color: "tertiary",
        icon: "bx:bxs-error-circle"
      },
      success: {
        color: "success",
        icon: "akar-icons:circle-check-fill"
      },
      info: {
        color: "primary",
        icon: "entypo:info-with-circle"
      },
      loading: {
        color: "primary",
        icon: "eos-icons:loading"
      }
    }[o.type] };
  }
}), u = { class: "transition-all flex items-center h-full px-2" }, _ = { class: "flex flex-col ml-4" }, y = ["innerHTML"];
function v(o, t, n, r, x, h) {
  const c = i("vs-icon");
  return a(), l("div", u, [
    p(c, {
      size: 20,
      name: o.content.icon,
      color: o.content.color
    }, null, 8, ["name", "color"]),
    e("div", _, [
      e("div", {
        class: "text-sm",
        innerHTML: o.text
      }, null, 8, y)
    ])
  ]);
}
const B = /* @__PURE__ */ d(f, [["render", v]]);
export {
  B as v
};
//# sourceMappingURL=vsToast-C2RNE97r.mjs.map
